(function () {
  'use strict';

  const drawer  = document.getElementById('mt-cart-drawer');
  const overlay = document.getElementById('mt-cart-overlay');
  const closeBtn = document.getElementById('mt-cart-close');
  const openBtn  = document.getElementById('mt-cart-btn');

  if (!drawer) return;

  /* ---- Toast notification ---- */
  const toast = document.getElementById('mt-toast');
  let toastTimer;

  function showToast() {
    if (!toast) return;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 1800);
  }

  /* ---- Open / Close ---- */
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn?.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    openBtn?.focus();
  }

  openBtn?.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* ---- Public API — called by product forms after add-to-cart ---- */
  window.MTCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refresh,
  };

  /* ---- Re-render the items area via Shopify Sections API ---- */
  async function refresh() {
    const body = drawer.querySelector('.mt-cart-body');
    if (body) body.classList.add('is-loading');

    try {
      const res  = await fetch('/?sections=mt-cart-drawer', { cache: 'no-store' });
      const data = await res.json();
      const html = data['mt-cart-drawer'];
      if (!html) return;

      const parser  = new DOMParser();
      const doc     = parser.parseFromString(html, 'text/html');

      /* Replace the re-renderable zone */
      const newZone = doc.querySelector('[data-cart-render]');
      const oldZone = drawer.querySelector('[data-cart-render]');
      if (newZone && oldZone) {
        oldZone.innerHTML = newZone.innerHTML;
      }

      /* Update all cart count badges in the header */
      const newCount = doc.querySelector('.mt-cart-count-badge');
      if (newCount) {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = newCount.textContent;
          el.style.display = newCount.textContent === '0' ? 'none' : '';
        });
      }

      /* Re-bind item events */
      bindItemEvents();
    } finally {
      if (body) body.classList.remove('is-loading');
    }
  }

  /* ---- Cart item events ---- */
  function bindItemEvents() {
    /* Quantity buttons */
    drawer.querySelectorAll('.mt-qty__btn').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        await updateItem(key, qty);
      });
    });

    /* Remove buttons */
    drawer.querySelectorAll('.mt-cart-item__remove').forEach((btn) => {
      btn.addEventListener('click', async () => {
        await updateItem(btn.dataset.key, 0);
      });
    });
  }

  async function updateItem(key, quantity) {
    const body = drawer.querySelector('.mt-cart-body');
    if (body) body.classList.add('is-loading');

    try {
      await fetch(window.routes?.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      await refresh();
    } catch (err) {
      console.error('[MTCart] update failed', err);
      if (body) body.classList.remove('is-loading');
    }
  }

  /* ---- Intercept add-to-cart forms ---- */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('[action*="/cart/add"]')) return;

    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitBtn.textContent;
      submitBtn.textContent = '—';
    }

    try {
      const formData = new FormData(form);
      await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        body: formData,
      });
      await refresh();
      openDrawer();
      showToast();
    } catch (err) {
      console.error('[MTCart] add failed', err);
      /* Fall back to native form submit */
      form.submit();
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.originalText || 'Add to bag';
      }
    }
  });

  /* ---- Initial bind ---- */
  bindItemEvents();

  /* ---- Re-bind after theme editor section reload ---- */
  document.addEventListener('shopify:section:load', () => {
    bindItemEvents();
  });
})();
